export default class PlayProgressBar {
    constructor(parent, l18n, titleTemplate) {
        this.l18n = l18n;
        this.parent = parent;

        if (!titleTemplate) {
            titleTemplate = PlayProgressBar.createTitleTextElement(l18n.get('packPlay.progressBar.title'));
        }

        this.parent.append(`
<div class="fl-progress-bar">
    <div class="fl-progress-bar__title">${titleTemplate}</div>
    <div class="fl-progress-bar__bar">
        <div class="fl-progress-bar__thumb"></div>
    </div>
</div>
        `);
        this._resize();
    }

    /**
     * @param {string} label
     * @param {string} [bindId]
     * @returns {string}
     */
    static createTitleTextElement(label, bindId) {
        if (!bindId) {
            bindId = 'message';
        }
        return `
<div class="fl-progress-bar__title-text">
    <span class="fl-progress-bar__title-text-label">${label}</span>
    <span class="fl-progress-bar__title-text-val" data-bind="${bindId}"></span>
</div>
        `;
    }

    setCustomText(bindId, val) {
        this.parent.find(`span[data-bind=${bindId}]`).text(val);
        this._resize();
    }

    set text(val) {
        this.setCustomText('message', val);
        this._resize();
    }

    set percent(val) {
        this.parent.find('.fl-progress-bar__thumb').width(val + '%');
        this._resize();
    }

    _resize() {
    }
}
